import { IsNotEmpty } from "class-validator";

export class PasswordInput {
  @IsNotEmpty({ message: "Password is required" })
  public password: string;
}
